import { ThemeProvider } from "@mui/material";
import "./App.css";
import { theme } from "./theme";
import { BrowserRouter } from "react-router";
import Router from "./router/router";
import store from "./store/store";
import { Provider } from "react-redux";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <Router />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
